export const PropositoOperacao = [
    {key:0, text:'Venda'},
    {key:1, text:'Compra'},
    {key:2, text:'Contranota de produtor rural'},
    {key:3, text:'Serviço'},
    {key:4, text:'Remessa'},
    {key:5, text:'Retorno'}
]